module.exports = __webpack_public_path__ + "img/qrCode.820bdee5.svg";